var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"we-toolbar"},[_c('li',{on:{"click":function($event){return _vm.openPanel('log')}}},[_c('Icon',{attrs:{"type":"md-list-box","size":"14"}}),_vm._v(" "),_c('span',{staticClass:"v-toolbar-icon"},[_vm._v(_vm._s(_vm.$t('message.workBench.body.script.toolbarProgress.log')))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }